define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var Media = require("media");
    var GridViewFilterLayout = require("ui.plugins/gridView/filter/views/GridViewFilterLayout");
    var Loader = require("ui/loader/Loader");
    var Translator = require("i18n/translator");
    var _ = require("underscore");
    var $ = require("jquery");

    var pressedKeyMap = {};

    //============================================================
    // Marionette.GridView
    //============================================================


    Marionette.GridView = Marionette.CompositeView.extend({

        constructor: function (options) {

            Marionette.CompositeView.prototype.constructor.call(this, options);

            this._avoidListeningToOriginalAddRemove();

            this.listenTo(this.model, "change", this.filter); //listening to changes in the gridModel: filter changes which are made by the GridViewFilterLayout
            this.listenTo(this.collection, "reRender", this.render, this);
            this.permutation = options.permutation || Marionette.GridView.PERMUTATION.A;
            this.comparators = options.comparators || [];
            this.filters = options.filters || [];
            this.isSortEnabled = true;
            this.openFilterName = null;
            this.filterVent = Media.vent();
            this.isShowLoader = _.has(options, "isShowLoader") ? options.isShowLoader : false;
            this.isShowAnimation = _.has(options, "isShowAnimation") ? options.isShowAnimation : true;
            this.textLoader = options.textLoader || {};
            this.listenTo(this.filterVent, "gridView:show:filteringLoader", this._showFilteringLoader);
        },

        //---------------------------------------------------
        // render
        //---------------------------------------------------

        render: function () {

            Marionette.CompositeView.prototype.render.call(this);

            //avoid listening to collection add/remove events ( moved from constructor due to marrionette changes
            this._avoidListeningToOriginalAddRemove();

            var table = this.$el.find("table");

            if(table){
                this.setTheme(table);
                this.setSortingClick(table);
                this.setFilteringClick(table);
                this.setActiveFiltersOnRender();
                this.addAriaSortAttribute(table);
                this.setKeyboardEventListener(table);
            }
        },

        allowSorting: function(isSortEnabled) {
            this.isSortEnabled = isSortEnabled;
        },

        //---------------------------------------------------

        setTheme: function (table) {
            table.addClass("table-perm" + this.permutation);
        },

        //---------------------------------------------------

        setSortingClick: function (table) {
            var that = this;

            table.on("click", "th .order, th[data-comparator] .content", function(){
                if (that.isSortEnabled) {
                    if(that.isShowLoader) {
                        that.showLoader({textLoader: that.textLoader.sorting, isShowAnimation: that.isShowAnimation});
                        setTimeout(_.bind(function(){
                            that._tableSortingClick(that, this, table);
                            that.closeLoader();
                        }, this), 200);
                    } else {
                        that._tableSortingClick(that, this, table);
                    }
                }
            });
        },

        //-------------------------------------------------

        setFilteringClick: function (table) {
            var that = this;

            table.on("click", "th .filter", function(){
                var filterName = $(this).parents("th").attr("data-filter");
                var openNewFilter = _.isNull(that.openFilterName) || that.openFilterName !== filterName;

                // close open filter when filter icon clicked (outside clicks are handled inside the GridViewFilterLayout view):
                if (!_.isNull(that.openFilterName) ||that.openFilterName === filterName) {
                    that.filterVent.trigger("gridView:closeFilter");
                    that.openFilterName = null;
                }

                if (openNewFilter) { //open the filter if an icon of a closed filter is clicked
                    var filterObject = _.where(that.filters, {name: filterName})[0];
                    if(filterObject) { //continue to open the filter only if there are filter params defined for it
                        var filterView = new GridViewFilterLayout({
                            targetElement: $(this),
                            model: that.model,
                            filterName: filterName,
                            filterTitle: filterObject.filterTitle,
                            filterType: filterObject.type,
                            filterData: filterObject.getFilterData({gridModel: that.model}),
                            vent: that.filterVent,
                            isShowLoader: that.isShowLoader
                        });
                        filterView.render();

                        that.openFilterName = filterName;
                        $(this).addClass("open-filter");

                        that.listenTo(filterView, "close", function () {
                            this.$el.find(".open-filter").removeClass("open-filter");
                            that.openFilterName = null;
                            if(that.isShowLoader) {
                                that.closeLoader();
                            }
                        }, this);
                    }
                }
            });
        },

        //-------------------------------------------------

        cleanHeaderColumns:function(table){

            table.find("th").each(function (index, item) {
                $(item).attr("aria-sort", "none");
                $(item).find(".order").removeClass("asc desc");
                $(item).removeClass("sorted");
            });
        },

        addAriaSortAttribute: function(table) {
          table.find("th").each(function(index, item) {
              $(item).attr("aria-sort", "none");
          });
        },

        setKeyboardEventListener: function(table) {
            var that = this;

            table.on("keyup", function(eventObject){
                that.handleShortcut(that, eventObject);
            });

            table.on("keydown", function(eventObject){
                that.handleShortcut(that, eventObject);
            });
        },

        handleShortcut: function (that, e) {
            var origEvent = e.originalEvent;
            pressedKeyMap[origEvent.code] = origEvent.type === "keydown";
            if ((pressedKeyMap.KeyA && pressedKeyMap.AltLeft && pressedKeyMap.ShiftLeft) ||
                (pressedKeyMap.KeyA && pressedKeyMap.AltRight && pressedKeyMap.ShiftRight)){
                e.preventDefault();
                pressedKeyMap = {};
                that.trigger("gridView:shortcut:openActionMenu");
            }
        },

        //---------------------------------------------------
        // appendHtml
        //---------------------------------------------------

        appendHtml: function (collectionView, itemView, index) {
            if(index%2 === 0){
                itemView.$el.addClass("odd");
            }else{
                itemView.$el.addClass("even");
            }
            //append html is using buffering we dont really want to override it .
            // but if we do we need to use the same buffering technique
            Marionette.CompositeView.prototype.appendHtml.call(this,collectionView,itemView,index);
        },


        //--------------------------------------------------
        // filter
        //--------------------------------------------------
        /**
         * In case the grid view is rendered with already active filters - mark them
         * and filter them :)
         */
        setActiveFiltersOnRender: function() {
            var needToFilter = false;
            var filters =  this.model.get("filters") || {};

            _.each(filters, _.bind(function(filterValue,filterName){
                var isFiltered = (!_.isEmpty(filterValue));
                if (isFiltered){
                    needToFilter = true;
                }
                //mark filter in table - if it exists
                var filterTh = this.$("th[data-filter=" + filterName + "]");
                var filterSpan = filterTh.find(".filter");
                filterSpan.toggleClass("filtered", isFiltered);

            },this));

            if (needToFilter){
                this.collection.organize({filterModel: this.model});
            }
        },

        filter:function(gridModel) {
            var changedFilterName = _.keys(gridModel.changed.filters)[0];
            var filterTh = this.$("th[data-filter=" + changedFilterName + "]");
            var filterSpan = filterTh.find(".filter");
            var isFiltered = (!_.isEmpty(gridModel.changed.filters[changedFilterName]));

            filterSpan.toggleClass("filtered", isFiltered);
            this.collection.organize({
                "filterModel": gridModel
            });
        },

        showLoader: function (options) {
            var permutation = _.has(options, "permutation") ? options.permutation : Loader.PERMUTATION.A;
            var el = _.has(options, "el") ? options.el : this.$el.find("table");
            var zIndex = _.has(options, "zIndex") ? options.zIndex : 999999;
            var text = _.has(options, "textLoader") ? Translator.translate(options.textLoader) : '';
            var isShowAnimation = _.has(options, "isShowAnimation") ? options.isShowAnimation : true;
            var button = _.has(options, "button") ? options.button : '';

            if (!this.loader) {
                this.loader = new Loader({
                    permutation: permutation,
                    el: el,
                    zIndex: zIndex,
                    text: text,
                    isShowAnimation: isShowAnimation,
                    button: button
                });
                this.loader.render();
            }
        },

        closeLoader: function () {
            if (this.loader) {
                this.loader.close();
                this.loader = null;
            }
        },

        _avoidListeningToOriginalAddRemove: function(){
            this.stopListening(this.collection, "add", this.addChildView);
            this.stopListening(this.collection, "remove", this.removeItemView);
        },

        _showFilteringLoader: function() {
            if(this.isShowLoader) {
                this.showLoader({textLoader: this.textLoader.filtering, isShowAnimation: this.isShowAnimation});
            }
        },

        _tableSortingClick: function (scope, contentScope, table) {
            var comparatorName = $(contentScope).parents("th").attr("data-comparator");
            if(_.isString(comparatorName)){
                var comparators = _.where(scope.comparators, {name:comparatorName});
                var comparatorFunction = _.isEmpty(comparators) ? comparatorName : comparators[0].func;

                var orderByShort = $(contentScope).parents("th").find(".order").hasClass("asc") ? "desc" : "asc";
                var orderByLong = orderByShort === "asc" ? "ascending" : "descending";
                scope.cleanHeaderColumns(table);
                $(contentScope).parents("th").find(".order").addClass(orderByShort);
                $(contentScope).parents("th").addClass("sorted");
                $(contentScope).parents("th").attr("aria-sort", orderByLong);

                scope.collection.organize({
                    comparator:comparatorFunction,
                    orderBy:orderByShort
                });
            }
        }
    });

    Marionette.GridView.LOADER_TEXT = {
        SEARCHING : "LEUIComponents.gridView.loader.searching",
        FILTERING : "LEUIComponents.gridView.loader.filtering",
        SORTING   : "LEUIComponents.gridView.loader.sorting",
        LOADING   : "LEUIComponents.gridView.loader.loading"
    };

    Marionette.GridView.PERMUTATION = {
        A   :"A",
        B   :"B"
    };

    Marionette.GridView.FILTERS = {};
    Marionette.GridView.FILTERS.TYPES = GridViewFilterLayout.FILTER_TYPES;

    return  Marionette;
});
